module.exports = __webpack_public_path__ + "img/9788955617207.b838faed.jpg";